import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler as BaseErrorHandler, inject, isDevMode, Service } from '@angular/core';
import { AlertSnackBarService } from '../../services';
import { AppException } from './exceptions/app-exception';

@Service()
export class ErrorHandler implements BaseErrorHandler {
  private alertSnackbar = inject(AlertSnackBarService);

  private logError(error: unknown) {
    if (isDevMode()) {
      console.error(error);
    }
  }

  handleError(error: unknown) {
    if (error instanceof AppException) {
      this.alertSnackbar.error({ message: error.message });
      this.logError(error.message);

      const details = error.details;
      if (details) {
        this.logError(details);
      }

      // Log the cause itself or its message if it's an Error-like object
      const cause = error.cause;
      if (cause) {
        if (cause instanceof Error || (typeof cause === 'object' && 'message' in cause)) {
          this.logError(cause.message);
        } else {
          this.logError(cause);
        }
      }

      return;
    }

    // Catch unhandled HttpErrorResponse errors
    if (error instanceof HttpErrorResponse) {
      this.alertSnackbar.error({ message: 'A network related error occurred!' });
      this.logError(error);
      return;
    }

    // Handle unknown errors
    this.logError(error);
  }
}
